function dataLayerLinkClick(event, linkCategory, linkLabel) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    linkCategory,
    linkLabel
  });
}
document.addEventListener('DOMContentLoaded', function() {
  const body = document.querySelector('body'); 
  body.addEventListener('click', function(evt) {
    const link = evt.target.closest("a, button");
    if (link && link.hasAttribute('data-click-category') && link.hasAttribute('data-click-label')) {
      dataLayerLinkClick('call_to_action', link.dataset.clickCategory, link.dataset.clickLabel);
    }
  })
})
